






import { Component, Vue } from "vue-property-decorator";
import MenuSection, { MenuSectionData } from "./MenuSection.vue";

@Component({ components: { MenuSection } })
export default class MenuWall extends Vue {
  generalSection: MenuSectionData = {
    title: "",
    items: [
      {
        title: "Importazione audience media",
        icon: "media-tv",
        url: "settings-audience-import",
        iconSize: 32,
      },
      {
        title: "Gestione mezzi",
        icon: "media-press",
        url: "settings-media",
        iconSize: 32,
      },
      {
        title: "Gestione tipi di media",
        icon: "media-radio",
        url: "settings-medium-types",
        iconSize: 32,
      },
      {
        title: "Gestione utenti",
        icon: "menu-clients",
        url: "settings-users",
        iconSize: 16,
      },
      {
        title: "Richiesta di supporto",
        icon: "menu-clients",
        url: "settings-support",
        iconSize: 16,
      },
    ],
  };
}
